import React from "react";
import { Box, Card, Collapse, Grid } from "@mui/material";

import ActiveFilters from "../../../../../Components/filters/ActiveFilters";
import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
}) => {
  // All filters in the order they appear
  const activeFilterDefinitions = [
    // Standard filters - in order
    {
      type: "standard",
      id: "employeeName",
      label: "Employee Name",
      value: submittedData.employeeName,
    },
    {
      type: "standard",
      id: "deviceNumber",
      label: "Device Number",
      value: submittedData.deviceNumber,
    },
    {
      type: "standard",
      id: "status",
      label: "Status",
      value: submittedData.status,
    },
    {
      type: "numericRange",
      id: "totalOrders",
      label: "Total Orders",
      minValue: submittedData.totalOrdersMin,
      maxValue: submittedData.totalOrdersMax,
    },
    {
      type: "numericRange",
      id: "priorityOrders",
      label: "Priority Orders",
      minValue: submittedData.priorityOrdersMin,
      maxValue: submittedData.priorityOrdersMax,
    },
    {
      type: "numericRange",
      id: "orderLines",
      label: "Order Lines",
      minValue: submittedData.orderLinesMin,
      maxValue: submittedData.orderLinesMax,
    },
    {
      type: "numericRange",
      id: "totalItems",
      label: "Total Items",
      minValue: submittedData.totalItemsMin,
      maxValue: submittedData.totalItemsMax,
    },
  ];

  // Helper function to remove numeric range filters
  const handleRemoveNumericRange = (rangeId) => {
    if (rangeId === "totalOrders") {
      handleRemove("totalOrdersMin");
      handleRemove("totalOrdersMax");
    } else if (rangeId === "priorityOrders") {
      handleRemove("priorityOrdersMin");
      handleRemove("priorityOrdersMax");
    } else if (rangeId === "orderLines") {
      handleRemove("orderLinesMin");
      handleRemove("orderLinesMax");
    } else if (rangeId === "totalItems") {
      handleRemove("totalItemsMin");
      handleRemove("totalItemsMax");
    }
  };

  return (
    <Box>
      <Grid item xs={12}>
        <Collapse in={filterOpen}>
          <Card>
            <Box p={4}>
              <FilterItems
                filterData={filterData}
                handleChangeFilter={handleChangeFilter}
                handleFilter={handleFilter}
                handleClearFilters={handleClearFilters}
              />
            </Box>
          </Card>
        </Collapse>
      </Grid>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
        onRemoveNumericRange={handleRemoveNumericRange}
      />
    </Box>
  );
};

export default Filter;
